import api from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const useDeleteSports = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['deleteSport'],
    mutationFn: (sportId: string) => {
      return api.sports.deleteSports(sportId);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sports'] });
      toast.success(t('toast.deletedServicesCategory'));
      navigate(-1);
    },
    retry: false
  });
};

export default useDeleteSports;
